import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Portal } from 'react-overlays';
import hasDom from 'has-dom';

// utilities
import clsx from 'clsx';

/**
 * The SideBar component is a container for any content that will either render inline or off canvas based on an isDocked prop.
 * If isDocked prop is false, then the contents will render off canvas and be triggered from the show prop.
 * The off canvas functionality can be achieved from the right or left side of the screen.
 * */
class SideBar extends PureComponent {
  constructor(props) {
    super(props);
    this.scrollTop = 0;
    this.container = null;
  }
  componentDidMount() {
    this.container = this.props.container && this.props.container.getDOMNode() || document.body;
  }
  componentDidUpdate(nextProps) {
    if (hasDom() && this.props.show !== nextProps.show) {
      const openClassName = 'sidebar-open';
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const classNames = this.container.className.split(' ') || [];
      if (this.props.show) {
        if (!classNames.includes(openClassName)) {
          classNames.push(openClassName);
        }
        this.container.className = classNames.join(' ');
        this.container.style.top = `-${scrollTop}px`;
        this.scrollTop = scrollTop;
      } else {
        classNames.splice(classNames.indexOf(openClassName), 1);
        this.container.className = classNames.join(' ');
        this.container.style.top = null;
        window.scrollTo(0, this.scrollTop);
      }
    }
  }
  render() {
    const {
      isDocked,
      children,
      className,
      fullWidth,
      header,
      show,
      onHide,
      position = 'left',
      uiContext,
      ...rest
    } = this.props;
    const handleDialogClick = e => {
      if (e.target !== e.currentTarget) {
        return;
      }
      onHide();
    };
    const wrapperClassNames = clsx(className, {
      'side-bar-container': true,
      floating: !isDocked,
      active: !isDocked && show
    });
    const sidebarWidth = fullWidth ? 12 : 11;
    const sidebarClassNames = clsx({
      ['col-xs-' + sidebarWidth]: !isDocked,
      'side-bar-wrapper': true,
      'padding-horizontal-0': true,
      'sidebar-simple': uiContext === 'simple',
      [position]: !isDocked
    });
    const container = hasDom() && window.document.body;
    return show && /*#__PURE__*/_jsx(Portal, {
      "data-cmp": "sideBar",
      container: container
    }, void 0, /*#__PURE__*/React.createElement("div", Object.assign({}, rest, {
      className: wrapperClassNames,
      onClick: handleDialogClick,
      role: "button",
      tabIndex: "0"
    }), /*#__PURE__*/_jsx("div", {
      className: sidebarClassNames
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "side-bar-header"
    }, void 0, header), /*#__PURE__*/_jsx("div", {
      "data-cmp": "sideBar-content",
      className: "side-bar-content"
    }, void 0, children))));
  }
}
export default SideBar;